document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.js-booking-link');
  const pictures = document.querySelectorAll('.js-booking-picture');

  if (!links.length || !pictures.length) return;

  pictures[0].classList.add('visible');

  links.forEach(link => {
    link.addEventListener('mouseenter', () => {
      const index = link.dataset.index;

      pictures.forEach(pic => pic.classList.remove('visible'));

      const targetPic = document.querySelector(`.js-booking-picture[data-index="${index}"]`);
      if (targetPic) targetPic.classList.add('visible');
    });
  });
});
